import React, { useState, useEffect } from "react";
import AddStaff from "../../PageComponent/Staff/AddStaff/AddStaff";
import ViewStaff from "../../PageComponent/Staff/ViewStaff/ViewStaff";
import SecondaryHeader from "../../UI/SecondaryHeader/SecondaryHeader";
import axios from "../../../HOC/CreateAxios/CreateAxios";
import Layout from "../../../HOC/layout/Layout";
import ContextApi from "../../../HOC/ContextsAPI/ContextApi";

function Staff() {
  const [showData, setShowData] = useState("Add");
  const [Tbody, setTbody] = useState([]);

  const getStaff = () => {
    axios
      .get("/staff")
      .then((res) => {
        setTbody(res.data.data);
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getStaff();
  }, []);
  return (
    <ContextApi>
      <Layout>
        <div>
          <SecondaryHeader
            setShowData={setShowData}
            showData={showData}
            addBtn="Add Staff"
            viewBtn="View Staff"
            // SearchText={SearchText}
          />

          {showData === "Add" ? (
            <AddStaff setShowData={setShowData} getStaff={getStaff} />
          ) : (
            <ViewStaff
              setShowData={setShowData}
              getStaff={getStaff}
              Tbody={Tbody}
              setTbody={setTbody}
            />
          )}
        </div>
      </Layout>
    </ContextApi>
  );
}

export default Staff;
